const { getConfigurationsByIds, listAllConfigurations, getByServiceId } = require('./api')

module.exports = {
  getByIds: getConfigurationsByIds,
  listAll: listAllConfigurations,
  getByServiceId
}
